if(!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", e => {
          this.mountSlider();
        });
      }

      this.mountSlider();

      // iOS Safari: force play after full page load
      window.addEventListener('load', () => this.playVideos());

      window.addEventListener("shopify:block:select", e => {
        const selectedSlideIndex = +e.target.dataset.index;
        this.slider.slideTo(selectedSlideIndex, 600);
      });

      this.addKeyboardNavigation();
    }

    mountSlider() {
      const autoplayOptions = {
        delay: this.dataset.autoplayInterval
      };

      this.slider = new Swiper(this, {
        effect: "fade",
        rewind: true,
        slidesPerView: 1,
        speed: 600,
        followFinger: false,
        navigation: {
          nextEl: ".swiper-button--next",
          prevEl: ".swiper-button--prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (i, className) {
            return `
            <button class="${className}">
              <span>0${i + 1}</span>
              <svg class="square-progress" width="26" height="26">
                <rect class="square-origin" width="26" height="26" rx="5" ry="5" />
              </svg>
              <svg class="progress" width="18" height="18" style="inset-inline-start: ${
                0 - (i * 2.4 + 3.4)
              }rem">
                <circle class="circle-origin" r="8" cx="9.5" cy="9.5"></circle>
              </svg>
            </button>
            `;
          }
        },
        autoplay:
          this.dataset.autoplay === "true" ? autoplayOptions : false,
        on: {
          init: this.handleSlideChange.bind(this),
          slideChange: this.handleSlideChange.bind(this),
          // iOS Safari: play video after slider is ready and after each slide change
          afterInit: () => this.playVideos(),
          slideChangeTransitionEnd: () => this.playVideos()
        }
      });
    }

    // iOS Safari autoplay fix:
    // Safari requires explicit .play() call + muted/playsinline as DOM attributes
    playVideos() {
      const videos = this.querySelectorAll('.hero__media video');
      videos.forEach(video => {
        video.muted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.load();
        const p = video.play();
        if (p !== undefined) {
          p.catch(() => {
            // If autoplay still blocked, play on first touch (invisible to user)
            document.addEventListener('touchstart', () => video.play(), { once: true });
          });
        }
      });
    }

    handleSlideChange(swiper) {
      let headerInner = document.querySelector(".header__inner");
      let heroInners = document.querySelectorAll(".hero__inner");

      if (!headerInner || !heroInners) {
        return;
      }

      // change --transparent-header-menu-text-color value on document style attributes
      document.documentElement.style.setProperty(
        "--transparent-header-menu-text-color",
        heroInners[swiper.activeIndex].dataset.headerMenuTextColor
      );
    }

    addKeyboardNavigation() {
      document.addEventListener("keydown", event => {
        if (this.isInViewport()) {
          if (event.key === "ArrowRight") {
            const nextButton = this.querySelector(
              ".swiper-button--next"
            );
            if (nextButton) {
              nextButton.click();
            }
          }
          if (event.key === "ArrowLeft") {
            const prevButton = this.querySelector(
              ".swiper-button--prev"
            );
            if (prevButton) {
              prevButton.click();
            }
          }
        }
      });
    }

    isInViewport() {
      const rect = this.getBoundingClientRect();
      return (
        rect.top < window.innerHeight &&
        rect.bottom > 0 &&
        rect.left < window.innerWidth &&
        rect.right > 0
      );
    }

  }
  customElements.define('hero-slider', HeroSlider);
}